export const FILTER = function (value) {
  // slice to make a copy of array, then reverse the copy
  return value.slice().reverse()
}

export default {
  install (Vue) {
    Vue.filter('reverse', FILTER)
  }
}
